import * as LDClient from 'launchdarkly-js-client-sdk';

class LaunchDarklyService {
  client: any;

  init(
    {
      launchDarklyId,
      user,
      options,
    }: any,
  ) {
    this.client = LDClient.initialize(launchDarklyId, {
      key: user.id,
      email: user.email || null,
      firstName: user.firstname || null,
      lastName: user.lastname || null,
      custom: {
        locale: user.locale || null,
        roles: user.roles || null,
        countryCode: user.countryCode || null,
        skills: user.skills || null,
        state: user.state || null,
        ready: user.ready || null,
        segment: 'mkp',
      },
    }, options);
  }

  /**
   * variation
   * @param feature
   * @param default
   * return Boolean
   */
  variation(feature: string, defaultValue: boolean) {
    return this.client?.variation(feature, defaultValue);
  }

  close() {
    this.client.close();
  }
}

// Export LaunchDarkly as a single instance
const launchDarklyService = new LaunchDarklyService();
export default launchDarklyService;
